import React, {useState, useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { getNavIndex } from "../../features/common";
import { SHARE_URL} from '../../Constants';
import { setLoading, showMessage} from "../../features/common";
import { useTranslation } from 'react-i18next';
import { navigateTo } from '../../Helper';

const Nav = () => {
    const [state, setState] = useState({ current: 'home'});
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const navIndex = useSelector(getNavIndex);

    const changeNav = (selected) => {
        setState({...state, current:selected}); //move to  redox
        if(selected ==='home') {
            navigateTo(dispatch, navigate, '/home', 0);
        }
        if(selected ==='user') {
            navigateTo(dispatch, navigate, '/writer-profile', 1);
        }
    }

    const shareUrl = () => {
        if (location.pathname) {
            const link = location.pathname.startsWith('/provider')?SHARE_URL+location.pathname:SHARE_URL;
            if(navigator.share) {
                navigator.share({url:link, text:t('share_subject'), title:t('share_message')})
            } else {
                navigator.clipboard.writeText(link);
                dispatch(showMessage({message : 'copied_to_clipboard'}));
            }

        }
    }

    return <div className='footer-nav ltr'>
        <img src={'/images/nav/home'+(navIndex===0?'-active':'')+'.png'} onClick={() => changeNav('home')} className='ml5 mr5 nav-icon' alt=''/>
        <img src={'/images/nav/user'+(navIndex===1?'-active':'')+'.png'} onClick={() => changeNav('user')} className='ml5 mr5 nav-icon' alt=''/>
        <img src={'/images/nav/share'+(navIndex===2?'-active':'')+'.png'} onClick={() => shareUrl()} className='ml5 mr5 nav-icon' alt=''/>
    </div>;
};

export default Nav;